export default {
    data () {
        return {
            RULES: {
                Required: (v) => !!v || 'This field is mandatory'
            }
        }
    }
}